import { initDoc } from '../common/doc';
export function initLineItem(lineItem) {
    const init = Object.assign(Object.assign({}, initDoc()), { collection: 'line-items', galleryCategory: '', galleryRecordId: '', price_data: {
            currency: 'usd',
            tax_behavior: 'exclusive',
            unit_amount: 0,
            product_data: {
                name: '',
                description: '',
                images: [],
                metadata: {}
            }
        }, maxQty: 10, minQty: 1, qtyIncrement: 1, isAvailableForPickup: false, isDeliverable: true });
    return Object.assign(Object.assign({}, init), lineItem);
}
